/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateServerHeaderForm,
  UpdateServerHeaderForm$Outbound,
  UpdateServerHeaderForm$outboundSchema,
} from "../components/updateserverheaderform.js";

export type UpdateRemoteMcpServerHeaderSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UpdateRemoteMcpServerHeaderSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UpdateRemoteMcpServerHeaderSecurity = {
  option1?: UpdateRemoteMcpServerHeaderSecurityOption1 | undefined;
  option2?: UpdateRemoteMcpServerHeaderSecurityOption2 | undefined;
};

export type UpdateRemoteMcpServerHeaderRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updateServerHeaderForm: UpdateServerHeaderForm;
};

/** @internal */
export type UpdateRemoteMcpServerHeaderSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UpdateRemoteMcpServerHeaderSecurityOption1$outboundSchema:
  z.ZodMiniType<
    UpdateRemoteMcpServerHeaderSecurityOption1$Outbound,
    UpdateRemoteMcpServerHeaderSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function updateRemoteMcpServerHeaderSecurityOption1ToJSON(
  updateRemoteMcpServerHeaderSecurityOption1:
    UpdateRemoteMcpServerHeaderSecurityOption1,
): string {
  return JSON.stringify(
    UpdateRemoteMcpServerHeaderSecurityOption1$outboundSchema.parse(
      updateRemoteMcpServerHeaderSecurityOption1,
    ),
  );
}

/** @internal */
export type UpdateRemoteMcpServerHeaderSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UpdateRemoteMcpServerHeaderSecurityOption2$outboundSchema:
  z.ZodMiniType<
    UpdateRemoteMcpServerHeaderSecurityOption2$Outbound,
    UpdateRemoteMcpServerHeaderSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function updateRemoteMcpServerHeaderSecurityOption2ToJSON(
  updateRemoteMcpServerHeaderSecurityOption2:
    UpdateRemoteMcpServerHeaderSecurityOption2,
): string {
  return JSON.stringify(
    UpdateRemoteMcpServerHeaderSecurityOption2$outboundSchema.parse(
      updateRemoteMcpServerHeaderSecurityOption2,
    ),
  );
}

/** @internal */
export type UpdateRemoteMcpServerHeaderSecurity$Outbound = {
  Option1?: UpdateRemoteMcpServerHeaderSecurityOption1$Outbound | undefined;
  Option2?: UpdateRemoteMcpServerHeaderSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UpdateRemoteMcpServerHeaderSecurity$outboundSchema: z.ZodMiniType<
  UpdateRemoteMcpServerHeaderSecurity$Outbound,
  UpdateRemoteMcpServerHeaderSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UpdateRemoteMcpServerHeaderSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UpdateRemoteMcpServerHeaderSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function updateRemoteMcpServerHeaderSecurityToJSON(
  updateRemoteMcpServerHeaderSecurity: UpdateRemoteMcpServerHeaderSecurity,
): string {
  return JSON.stringify(
    UpdateRemoteMcpServerHeaderSecurity$outboundSchema.parse(
      updateRemoteMcpServerHeaderSecurity,
    ),
  );
}

/** @internal */
export type UpdateRemoteMcpServerHeaderRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdateServerHeaderForm: UpdateServerHeaderForm$Outbound;
};

/** @internal */
export const UpdateRemoteMcpServerHeaderRequest$outboundSchema: z.ZodMiniType<
  UpdateRemoteMcpServerHeaderRequest$Outbound,
  UpdateRemoteMcpServerHeaderRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updateServerHeaderForm: UpdateServerHeaderForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      updateServerHeaderForm: "UpdateServerHeaderForm",
    });
  }),
);

export function updateRemoteMcpServerHeaderRequestToJSON(
  updateRemoteMcpServerHeaderRequest: UpdateRemoteMcpServerHeaderRequest,
): string {
  return JSON.stringify(
    UpdateRemoteMcpServerHeaderRequest$outboundSchema.parse(
      updateRemoteMcpServerHeaderRequest,
    ),
  );
}
